import { FOR_UPDATE, StudentServicePath, WEEKLY_STREAM_SCHEDULE } from "utils/constants";
import EditStreamWeeklySchedule from "./Edit";

//permissions
export const resources = {
  isMenu: false,
  name: StudentServicePath + FOR_UPDATE + "/" + WEEKLY_STREAM_SCHEDULE,
  title: "Редактиране на занятия в поток",
  custom: <EditStreamWeeklySchedule />,
};
